export const PROGRAM_ACTIVITY_GET_SUCCESS = 'PROGRAM_ACTIVITY_GET_SUCCESS';
export const PROGRAM_ACTIVITY_GET_FAILURE = 'PROGRAM_ACTIVITY_GET_FAILURE';

export const PROGRAM_ACTIVITY_SUCCESS = 'PROGRAM_ACTIVITY_SUCCESS';
export const PROGRAM_ACTIVITY_FAILURE = 'PROGRAM_ACTIVITY_FAILURE';
